import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment-jalaali";
import Calendar from "./Calendar/Calendar";
import Loader from "../../Loader";
import HourSelection from "./HourSelection/index";
import Error from "./Error";
import { getDays } from "../../../Core/Days/action";
import { getHours } from "../../../Core/Hours/action";
import { getData, putData } from "../../../Core/Projects/action";
import { changeData, unchangeData } from "../../../Core/ChangeValues/action";
import nextArrow from "../../../Assets/Images/Components/Book/Map/next-step.png";
import calendarIcon from "../../../Assets/Images/Components/Book/Date/calendar-icon.png";
import styles from "../../../Assets/Styles/Components/Book/BookTime/bookTime.module.css";
import styles2 from "../../../Assets/Styles/Components/Book/Packages/Packages.module.css";
import styles3 from "../../../Assets/Styles/Components/Book/Map/MapView.module.css";

class BookTime extends Component {
  myRef = React.createRef();

  constructor() {
    super();
    this.state = {
      day: "",
      time: "",
      skip_start_time: false,
      selectTime: false,
    };
  }

  componentDidMount() {
    if (!this.props.project.slug) {
      if (window.location.search && window.location.search.substr(1)) {
        this.props.getData(
          Object.fromEntries(
            new URLSearchParams(window.location.search.substring(1))
          ).slug,
          {}
        );
        this.props.getDays(
          Object.fromEntries(
            new URLSearchParams(window.location.search.substring(1))
          ).slug
        );
      }
    }
    if (
      this.props.project.slug &&
      this.props.project.data &&
      this.props.project.data.skip_start_time
    ) {
      this.setState({ skip_start_time: true });
    }
    if (
      this.props.project.slug &&
      this.props.project.data &&
      this.props.project.data.start_time &&
      this.props.hours &&
      Object.keys(this.props.hours.hours).length !== 0
    ) {
      this.setState({
        day: moment(this.props.project.data.start_time, "YYYY-M-D").format(
          "jYYYY/jM/jD"
        ),
        time: moment(this.props.project.data.start_time).format("HH:mm"),
      });
    }

    if (
      this.props.project.slug &&
      this.props.project.data &&
      this.props.project.data.start_time &&
      this.props.hours &&
      Object.keys(this.props.hours.hours).length === 0
    ) {
      this.props.getDays(this.props.project.slug);
      this.props.getHours(
        this.props.project.slug,
        moment(
          moment(this.props.project.data.start_time, "YYYY-M-D").format(
            "jYYYY/jM/jD"
          ),
          "jYYYY/jM/jD"
        ).format("YYYY-M-D ")
      );
      this.setState({
        day: moment(this.props.project.data.start_time, "YYYY-M-D").format(
          "jYYYY/jM/jD"
        ),
        time: moment(this.props.project.data.start_time).format("HH:mm"),
      });
    }
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    if (this.props.change && this.props.project.slug) {
      this.props.getDays(this.props.project.slug);
      this.setState({ day: "", time: "" });
      this.props.unchangeData();
    }
  }

  componentDidUpdate(preProps) {
    if (
      (this.props.project &&
        this.props.project.data &&
        preProps.project.data.step !== this.props.project.data.step) ||
      (this.props.project &&
        !this.props.project.loading &&
        preProps.project.loading !== this.props.project.loading)
    ) {
      this.props.history.push(
        `/book/${this.props.project.data.step}?slug=${this.props.project.slug}`
      );
      this.props.changeData();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  skipTime = (status) => {
    this.setState({ skip_start_time: status });
    if (status) {
      console.log("status", status);
      const { slug, data } = this.props.project;
      this.props.putData(slug, {
        ...data,
        skip_start_time: status,
        step: this.props.history.location.pathname.slice(1).split("/")[1],
      });
    }
  };

  changeDaySelected = (day) => {
    this.setState({ day, time: "" });
    this.props.getHours(
      this.props.project.slug,
      moment(day, "jYYYY/jM/jD").format("YYYY-M-D ")
    );
    this.skipTime(false);
  };

  changeTimeSelected = (time) => () => {
    this.setState({ time });
    this.skipTime(false);
  };

  render() {
    const { days, hours } = this.props;
    const { day, time } = this.state;
    // Someone who picked a package on a landing page never sees the package
    // step, and the landing priced it for whichever city was selected there.
    // Show what they are carrying, priced for their own city, with a way back.
    const summary = this.props.project && this.props.project.data && this.props.project.data.package_summary;
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="custom-box">
              {summary && (
                <div className={styles.packageSummary}>
                  <span>
                    پکیج شما: {summary.duration} — {summary.title}
                    {summary.price_from && summary.price_to && summary.price_from !== summary.price_to
                      ? ` · ${new Intl.NumberFormat().format(Number(summary.price_from))} تا ${new Intl.NumberFormat().format(Number(summary.price_to))} تومان`
                      : ''}
                    {summary.price_from && summary.price_from === summary.price_to
                      ? ` · ${new Intl.NumberFormat().format(Number(summary.price_from))} تومان`
                      : ''}
                  </span>
                  <button
                    type="button"
                    className={styles.packageSummaryChange}
                    onClick={() => this.props.history.push(`/book/package?slug=${this.props.project.slug}`)}
                  >
                    تغییر
                  </button>
                </div>
              )}
              <div className={styles.labelBar}>
                {!this.state.selectTime ? (
                  <button id="select-time" onClick={(_) => this.setState({ selectTime: !this.state.selectTime })} className={`${styles.btn} ${styles.btnDate}`} type="button">
                    <div className={styles.btnContent}>
                      <div className={styles.btnImg}>
                        <img src={calendarIcon} alt="out-side" />
                      </div>
                      <div className={styles.btnTexts}>
                        <h4>انتخاب تاریخ</h4>
                        <p>
                          زمان مناسب را الان انتخاب کنید.
                        </p>
                      </div>
                    </div>
                  </button>
                ) : null}
                <button onClick={(_) => this.skipTime(true)} className={`${styles.btn} ${styles.btnDate}`} type="button">
                  <div className={styles.btnContent}>
                    <div className={styles.btnImg}>
                      <img src={nextArrow} alt="out-side" />
                    </div>
                    <div className={styles.btnTexts}>
                      <h4>هنوز تصمیم نگرفته ام</h4>
                      <p>
                        بعدا با مشورت متخصص انتخاب می کنم.
                      </p>
                    </div>
                  </div>
                </button>
              </div>
              {this.state.selectTime ? (
                <>
                  <div className="row">
                    <div className={`${styles.containerBox} col-12 col-md-6`}>
                      <div className={styles.title}>
                        {" "}
                        <p> انتخاب روز </p>
                      </div>
                      <div className={styles.container}>
                        <Calendar
                          onChange={this.changeDaySelected}
                          avilabelsDays={
                            days && !days.error && days.days ? days.days : []
                          }
                          choicedDay={day}
                        />
                      </div>
                    </div>
                    <div
                      className={`${styles.containerBox} ${
                        !this.state.day ? styles.inVisible : ""
                      } col-12 col-md-6`}
                    >
                      <div className={styles.title}>
                        {" "}
                        <p> انتخاب ساعت (از بین ساعات متخصصین آماده رزرو):</p>
                      </div>
                      <div className={styles.container} ref={this.myRef}>
                        {day && hours && hours.loading && <Loader scale={1} />}
                        {day &&
                          hours &&
                          hours.hours !== {} &&
                          hours.hours.hours &&
                          hours.hours.hours.length !== 0 && (
                            <HourSelection
                              hours={hours.hours.hours}
                              dayTitle={hours.hours.date}
                              day={day}
                              time={time}
                              onChange={this.changeTimeSelected(time)}
                            />
                          )}
                        {day &&
                          hours &&
                          hours.hours !== {} &&
                          hours.hours.error && (
                            <Error error={hours.hours.error} />
                          )}
                      </div>
                    </div>
                    <div className={`${styles.containerBox} mx-2 mt-4`}>
                      <p style={{ fontSize: "12px" }}>
                        <span style={{ color: "red", marginLeft: "3px", fontSize: "12px" }}>
                          توجه:
                        </span>
                        پنجشنبه ها روز پیک می باشد و در روز های پیک مبلغ ۲۰٪ افزایش خواهد یافت.
                      </p>
                    </div>
                  </div>
                  {/* <div className={styles2.packages}>
                    <div className={`${styles2.options} ${styles2.bgBlue}`}>
                      <div className={styles2.item}>
                        <div className={styles2.icon}>
                          <i className="far fa-calendar" />
                        </div>
                        <p>
                          با هماهنگی متخصص می توانید یک بار تاریخ عکاسی را تغییر
                          دهید.
                        </p>
                      </div>
                    </div>
                  </div> */}
                </>
              ) : (
                true
              )}
              <div className={styles2.packages}>
                <div className={`${styles2.options}`}>
                  <div className={styles2.item}>
                    <p className={styles.notice}>
                      <i className="far fa-phone" /> { }
                      پس از پرداخت، امکان تماس و هماهنگی مستقیم با متخصص فراهم می‌شود.
                    </p>
                    <br />
                    <p className={styles.notice}>
                      <i className="far fa-calendar" /> { }
                      در صورت نیاز، می‌توانید یک‌بار تاریخ را با هماهنگی متخصص تغییر دهید.
                    </p>
                    <br />
                    <p className={styles.notice}>
                      <i className="far fa-check" /> { }
                      حضور متخصص در زمان رزرو، پس از تأیید نهایی در سیستم کادرو تضمین می‌شود.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    days: state.days,
    hours: state.hours,
    project: state.project,
    change: state.change.change,
  };
};
export default connect(mapStateToProps, {
  getDays,
  getHours,
  getData,
  putData,
  changeData,
  unchangeData,
})(withRouter(BookTime));
